import axios from 'axios';
import { AuthResponse } from 'api/types';
import { getApplication } from 'config/configure';
import {
  ForgotPasswordResponse,
  ResetPasswordResponse,
  UserRegistrationRequest,
  LoginRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
} from './types';
import { getAuthEndpoint } from './utils';

export async function registerUser(
  args: UserRegistrationRequest,
): Promise<AuthResponse> {
  const { data } = await axios.post<AuthResponse>(getAuthEndpoint('register'), {
    ...args,
    application: getApplication(),
    skipPasswordConfirmation: true,
  });

  return data;
}

export async function login(args: LoginRequest): Promise<AuthResponse> {
  const { data } = await axios.post<AuthResponse>(getAuthEndpoint('login'), {
    ...args,
    application: getApplication(),
  });

  return data;
}

export async function forgotPassword(
  args: ForgotPasswordRequest,
): Promise<ForgotPasswordResponse> {
  const { data } = await axios.post<ForgotPasswordResponse>(
    getAuthEndpoint('forgotPassword'),
    {
      ...args,
      application: getApplication(),
    },
  );

  return data;
}

export async function resetPassword(
  args: ResetPasswordRequest,
): Promise<ResetPasswordResponse> {
  const { data } = await axios.post<ResetPasswordResponse>(
    getAuthEndpoint('resetPassword'),
    args,
  );
  return data;
}
